import { useEffect, useState, useRef } from 'react'

interface UseCountUpOptions {
  duration?: number
  startOnMount?: boolean
}

export function useCountUp(
  target: number,
  isVisible: boolean,
  options: UseCountUpOptions = {},
) {
  const { duration = 2000 } = options
  const [count, setCount] = useState(0)
  const hasAnimated = useRef(false)

  useEffect(() => {
    if (!isVisible || hasAnimated.current) return
    hasAnimated.current = true

    const startTime = performance.now()
    const startValue = 0

    const animate = (currentTime: number) => {
      const elapsed = currentTime - startTime
      const progress = Math.min(elapsed / duration, 1)

      // Easing function (ease-out cubic)
      const easeOut = 1 - Math.pow(1 - progress, 3)
      const currentValue = Math.floor(
        startValue + (target - startValue) * easeOut,
      )

      setCount(currentValue)

      if (progress < 1) {
        requestAnimationFrame(animate)
      }
    }

    requestAnimationFrame(animate)
  }, [isVisible, target, duration])

  return count
}
